module.exports = __webpack_public_path__ + "img/people.49f70c39.png";